import { render } from "./DetalharBrinde.vue?vue&type=template&id=345b21f6&scoped=true"
import script from "./DetalharBrinde.vue?vue&type=script&lang=js"
export * from "./DetalharBrinde.vue?vue&type=script&lang=js"

import "./DetalharBrinde.vue?vue&type=style&index=0&id=345b21f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345b21f6"]])

export default __exports__